import PushCollectionChangesModal from './PushCollectionChangesModal.container'

export default PushCollectionChangesModal
